export { default as default } from './content';
